interface Date {
    YYMMDD(): string;
    YYMMDDHHMM(): string;
    YYMMDDHHMM2(): string;
    YYMMDDHHMMSS(): string;
    WO_Number(): string;
    PO_Number(): string;
    ToEasternDateTime(): string;
    ToEasternDate(): string;
    addMonths(value): Date;
}
interface String {
    ToEasternDateTime(): string;
}

String.prototype.ToEasternDateTime = function () {
    try {
        if (this != "")
            return new Date(this).toLocaleString("en-US", { timeZone: "America/New_York" })
        else
            return ""
    } catch (error) {
        return ""
    }
}

Date.prototype.ToEasternDateTime = function () {
    try {
        if (this != "")
            return new Date(this).toLocaleString("en-US", { timeZone: "America/New_York" })
        else
            return ""
    } catch (error) {
        return ""
    }
}

Date.prototype.ToEasternDate = function () {
    try {
        if (this != "") {
            let onlyDate: any = new Date(this).toLocaleString("en-US", { timeZone: "America/New_York" }).split(',');
            return onlyDate[0];
        }
        else
            return ""
    } catch (error) {
        return ""
    }
}

Date.prototype.YYMMDD = function () {
    try {
        const yy: string = this.getFullYear().toString().slice(2, 4);
        const MM: string = (this.getMonth() + 1).toString().padStart(2, 0);
        const dd: string = this.getDate().toString().padStart(2, 0);

        return yy + MM + dd;
    } catch (error) {
        return ""
    }
};

Date.prototype.YYMMDDHHMM = function () {
    try {
        const yy: string = this.getFullYear().toString().slice(2, 4);
        const MM: string = (this.getMonth() + 1).toString().padStart(2, 0);
        const dd: string = this.getDate().toString().padStart(2, 0);
        const hh: string = this.getHours().toString().padStart(2, 0);
        const mm: string = this.getMinutes().toString().padStart(2, 0);
        // const ss:string = this.getSeconds().toString().padStart(2, 0);

        return yy + MM + dd + hh + ":" + mm;
    } catch (error) {
        return ""
    }
};

Date.prototype.YYMMDDHHMM2 = function () {
    try {
        const yy: string = this.getFullYear().toString().slice(2, 4);
        const MM: string = (this.getMonth() + 1).toString().padStart(2, 0);
        const dd: string = this.getDate().toString().padStart(2, 0);
        const hh: string = this.getHours().toString().padStart(2, 0);
        const mm: string = this.getMinutes().toString().padStart(2, 0);
        // const ss:string = this.getSeconds().toString().padStart(2, 0);

        return yy + MM + dd + hh + mm;
    } catch (error) {
        return ""
    }
};

Date.prototype.YYMMDDHHMMSS = function () {
    try {
        const yy: string = this.getFullYear().toString().slice(2, 4);
        const MM: string = (this.getMonth() + 1).toString().padStart(2, 0);
        const dd: string = this.getDate().toString().padStart(2, 0);
        const hh: string = this.getHours().toString().padStart(2, 0);
        const mm: string = this.getMinutes().toString().padStart(2, 0);
        const ss: string = this.getSeconds().toString().padStart(2, 0);

        return yy + MM + dd + hh + ":" + mm + ":" + ss;
    } catch (error) {
        return ""
    }
};

Date.prototype.WO_Number = function () {
    try {
        const yy: string = this.getFullYear().toString().slice(2, 4);
        const MM: string = (this.getMonth() + 1).toString().padStart(2, 0);
        const dd: string = this.getDate().toString().padStart(2, 0);
        const hh: string = this.getHours().toString().padStart(2, 0);
        const mm: string = this.getMinutes().toString().padStart(2, 0);
        // const ss:string = this.getSeconds().toString().padStart(2, 0);

        return "wo-" + yy + MM + dd + "-" + hh + mm;
    } catch (error) {
        return ""
    }
};

Date.prototype.PO_Number = function () {
    try {
        const yy: string = this.getFullYear().toString().slice(2, 4);
        const MM: string = (this.getMonth() + 1).toString().padStart(2, 0);
        const dd: string = this.getDate().toString().padStart(2, 0);
        const hh: string = this.getHours().toString().padStart(2, 0);
        const mm: string = this.getMinutes().toString().padStart(2, 0);
        // const ss:string = this.getSeconds().toString().padStart(2, 0);

        return "po-" + yy + MM + dd + "-" + hh + mm;
    } catch (error) {
        return ""
    }
};

Date.prototype.addMonths = function (value) {
    var n = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + value);
    this.setDate(Math.min(n, getDaysInMonth(this.getFullYear(), this.getMonth())));
    return this;
}

function isLeapYear(year): boolean {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
};

function getDaysInMonth(year, month) {
    return [31, (isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
};




// WEBPACK FOOTER //
// ./src/prototype.ts